<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form label-width="80px" label-position="left">
      <el-form-item :label="$t('SeaExport.FileType')" class="custom">
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_TransmitFileType"
          :default-value="oneFormData.fileType"
          style="width: 100%"
          :disabled="true"
          :method-params="{lob: job.lob }"
          :callback-params="{key:'fileType'}"
          @parentCallBack="setFileTypeSelectValue"
        />
      </el-form-item>
      <template v-if="backableShow">
        <el-form-item :label="$t('SeaExport.Back')" class="custom">
          <el-checkbox v-model="cbBack" />
        </el-form-item>
        <el-form-item v-if="cbBack" :label="$t('SeaExport.ReceivingDate')" class="custom">
          <el-date-picker
            v-model="oneFormData.backDate"
            type="date"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </template>

      <el-form-item :label="$t('SeaExport.TenBitCode')" class="custom">
        <el-input v-model="oneFormData.tenDigitCode" max-length="10" @change="tenDigitCodeChangeHandler" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.OperatingCompany')" class="custom">
        <el-input v-model="oneFormData.companyCname" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.FileNo')" class="custom">
        <el-input v-model="oneFormData.fileNo" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.CustomsBroker')" class="custom">
        <cargo-advance-select
          :select-type="selectTypeNames.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          :default-value="oneFormData.customsBroker||''"
          :method-params="{customsBroker:true,active:true}"
          @parentCallBack="p=>{oneFormData.customsBroker=p.value}"
        />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.TakeByCustomsBroker')" class="custom">
        <el-checkbox v-model="oneFormData.tax" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.CustomsDeclarationPages')" class="custom">
        <el-input-number v-model="oneFormData.customsPageNumber" :min="1" :max="9999" :precision="0" controls-position="right" style="width: 100%" />
      </el-form-item>
      <el-form-item class="custom">
        <el-checkbox v-model="oneFormData.customsTransfer">{{ $t('SeaExport.CustomsTransitOrNot') }}</el-checkbox>
        <el-checkbox v-model="oneFormData.commodityInspection">{{ $t('SeaExport.CommodityInspectionOrNot') }}</el-checkbox>
        <el-checkbox v-model="oneFormData.spotInspection">{{ $t('SeaExport.CustomsInspectionOrNot') }}</el-checkbox>
      </el-form-item>

      <el-form-item :label="$t('SeaExport.TradeMethod')" class="custom">
        <el-select v-model="oneFormData.tradeMode">
          <el-option :label="$t('SeaExport.All')" :value="0" />
          <el-option :label="$t('SeaExport.GeneralTrade')" :value="1" />
          <el-option :label="$t('SeaExport.Processing')" :value="2" />
          <el-option :label="$t('SeaExport.FeedingCounterparts')" :value="3" />
          <el-option :label="$t('SeaExport.SamplesOfAdvertisingProducts')" :value="4" />
          <el-option :label="$t('SeaExport.OtherImportsFree')" :value="5" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.Remarks')" class="custom">
        <el-input
          v-model="oneFormData.remark"
          type="textarea"
          :rows="3"
        />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.CustomerName')" class="custom">
        <el-input v-model="oneFormData.receiveCompany" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.ContactPerson')" class="custom">
        <cargo-advance-select
          v-if="isSe"
          :select-type="selectTypeNames.static_data_Contact"
          :allow-create="true"
          filterable
          :cache="false"

          :default-value="oneFormData.receivePerson"
          :static-options="contactList"
          @parentCallBack="contactChange"
        />
        <el-input v-if="!isSe" v-model="oneFormData.receivePerson" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.Tel')" class="custom">
        <el-input v-model="oneFormData.receiveTel" />
      </el-form-item>
      <el-form-item v-if="isSe" :label="$t('SeaExport.AddressOfContact')" class="custom">
        <el-input v-model="oneFormData.receiveAddress" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.CustomerAddress')" class="custom">
        <el-input
          v-model="oneFormData.expressAddress"

          type="textarea"
          :rows="3"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="enterHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
    <!--报关状态-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="isCustomsStatusTitle"
      :title="$t('SeaExport.StatusOfCustomsDeclaration')"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
    >
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptionsCustomsStatus"
        :column-defs="columnDefsCustomsStatus"
        :row-data="rowDataCustomsStatus"
        style="width:100%;height: 300px"
        @gridReady="params=>gridApiFileDetail=params.api"
      />
      <span slot="footer">
        <el-button @click="isCustomsStatusTitle=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import {
  saveFile,
  checkFileNoExist,
  getBusinessByCompany,
  getBusinessByTenDigitCode,
  businessCheckSaveUpdate,
  getGetCustomsStatusResult,
  updateRemarkHandler
} from '@/api/seaExport/file'
import { Company } from '@/class/model/mdm/Company'
import { File } from '@/class/model/booking/File'
import * as TransmitFileTypeConstants from '@/class/cargo/model/parameters/TransmitFileTypeConstants'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { ylQueryClickHandler, stateQueryClickHandler } from '@/class/cargo/model/utils/file'
import { sortByMultiField } from '@/utils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'EditCustomsFile',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  props: {
    backable: { type: Boolean, required: false, default: false },
    visible: { type: Boolean, required: true },
    job: {
      type: Object,
      required: true
    },
    isRemarkOnly: { type: Boolean, required: false, default: false },
    selectedFile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isCustomsStatusTitle: false,
      gridApiFileDetail: null,
      rowDataCustomsStatus: [],
      gridOptionsCustomsStatus: {
        context: {
          componentParent: this
        }
      },
      columnDefsCustomsStatus: [
        {
          headerName: this.$t('SeaExport.ReceiptTime'),
          field: 'RECEIPT_DATE',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ReceiptContent'),
          field: 'RECEIPT_CONTENT',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ReceiveReceiptTime'),
          field: 'DATE_CREATED',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.receiptCode'),
          field: 'RECEIPT_CODE',
          width: 100
        }
      ],
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      backableShow: false,
      cbBack: false,
      action: '',
      isGetMbl: true,
      title: '',
      isLockFileType: true,
      currentUser: {},
      bgdHp: false,
      isQuerying: false,
      business: null,
      oneFormData: new File().fillDefaultValue().getData(),
      contactList: [], // 联系人
      isSe: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        // this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.contactList = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    async onShow(action) {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      this.oneFormData = new File().fillDefaultValue().getData()
      this.isGetMbl = String(cache.config.get('fileMbl')) === '1'
      this.backableShow = action === 'add' && this.backable
      this.isSe = this.job ? (this.job.lob === 'SE') : false
      if (this.job && this.job.customerId > 0) {
        const customer = await Company.getCompanyById(this.job.customerId)
        if (customer) {
          this.contactList = await Company.loadContact(customer.uuid)
        }
      }
      this.action = action
      if (action === 'add') {
        this.addingFile()
      } else if (action === 'edit') {
        this.onFileEdit()
      } else if (action === 'clone') {
        this.onClone()
      }
    },
    async addingFile() {
      this.title = this.$t('Message.NewDocuments')
      const newObj = await this.createFileByJob()
      this.oneFormData = newObj
      if (this.job.lob === 'SE' && this.job.containerLoadType === 'BB') {
        this.oneFormData.customsBroker = this.job.bookingAgent
      }
      const interchangeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TransmitFileType, 'code', this.oneFormData.fileType, 'interchangeCode')
      this.bgdHp = TransmitFileTypeConstants.BGD_TYPE === interchangeCode
    },
    async createFileByJob() {
      const newobj = new File().fillDefaultValue().getData()
      newobj.jobUuid = this.job.uuid
      newobj.jobNo = this.job.jobNo
      newobj.tenDigitCode = ''
      newobj.companyCName = ''
      newobj.fileNo = ''
      newobj.customsBroker = 0
      newobj.receivePerson = ''
      newobj.receiveTel = ''
      newobj.receiveCompany = ''
      newobj.expressAddress = ''
      newobj.customsPageNumber = 1
      let company = { cmpIdx: this.job.customerId }
      company = new Company(company)
      if (company != null) {
        const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.customerId)
        if (companyCache) {
          newobj.receiveCompany = companyCache.chineseName
          newobj.expressAddress = companyCache.address
        }
        const contacts = this.isSe ? this.contactList : await company.getContactsBycmpIdx()
        // 获取业务上的联系人，若业务上无 则取默认联系人
        let contact = null
        if (this.isSe) {
          if (contacts && contacts.length > 0) {
            for (const item of contacts) {
              if (item.defaultContact) {
                contact = item
                break
              }
            }
            if (!contact) {
              contact = contacts[0]
            }
            if (contact) {
              newobj.receivePerson = contact.contactPerson
              newobj.receiveTel = contact.telephone
              newobj.receiveAddress = contact.address
            }
          }
        } else {
          if (contacts) {
            for (const item of contacts) {
              if (item.contactPerson === this.job.customerContact) {
                contact = item
                break
              }
            }
            if (!contact) {
              for (const item of contacts) {
                if (item.defaultContact) {
                  contact = item
                  break
                }
              }
            }
          }
          if (contact) {
            newobj.receivePerson = contact.contactPerson
            newobj.receiveTel = contact.telephone
          }
        }
      }
      newobj.receiveDate = new Date()
      newobj.tax = false
      newobj.remark = ''
      newobj.inputBy = this.currentUser.userId
      newobj.inputDate = new Date()
      newobj.branchId = this.$store.getters.currentOfficeId
      newobj.inputByDep = this.$store.getters.currentDeptId
      return newobj
    },
    // 新增编辑保存
    async enterHandler() {
      if (!this.validate()) return
      const option = {
        fileNo: this.oneFormData.fileNo,
        branchId: this.job.opOffice,
        fileType: this.oneFormData.fileType
      }
      let isExist = false
      await checkFileNoExist(option).then(res => {
        isExist = res.data
      })
      if (this.action === 'add' && isExist) {
        this.$message.warning(this.$t('Message.FileNumberAlreadyExists'))
        return
      }
      this.saveFile()
    },
    validate() {
      // 验证
      if (!this.oneFormData.fileType) {
        this.$message.warning(this.$t('Message.FileTypeCannotBeEmpty'))
        return false
      }
      if (!this.oneFormData.fileNo) {
        this.$message.warning(this.$t('Message.FileNumberCannotBeEmpty'))
        return false
      }
      return true
    },
    saveFile() {
      if (this.backableShow && this.cbBack) {
        this.oneFormData.state = 2
        this.oneFormData.backUser = this.currentUser.userId
      }
      if (this.isRemarkOnly) {
        const fileList = []
        const f = {}
        f.customsTransfer = this.oneFormData.customsTransfer || false
        f.customsPageNumber = this.oneFormData.customsPageNumber
        f.tradeMode = this.oneFormData.tradeMode || 0
        f.remark = this.oneFormData.remark
        f.uuid = this.selectedFile.uuid
        fileList.push(f)
        updateRemarkHandler(fileList).then(res => {
          this.innerVisible = false
          this.$message.success(this.$t('Message.SaveSuccessfully'))
          this.$emit('successHandler', res.data)
        })
      } else {
        saveFile(this.oneFormData).then(res => {
          this.innerVisible = false
          // 保存十位码
          this.businessSaveOrUpdate()
          this.$message.success('保存成功')
          this.$emit('successHandler', res.data)
        })
      }
    },
    onFileEdit() {
      this.title = this.$t('Message.EditDocuments')
      this.oneFormData = { ...this.selectedFile }
      const interchangeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TransmitFileType, 'code', this.oneFormData.fileType, 'interchangeCode')
      this.bgdHp = TransmitFileTypeConstants.BGD_TYPE === interchangeCode
    },
    async onClone() {
      this.title = this.$t('Message.NewDocuments')
      const cloneData = await this.createFileByJob()
      cloneData.fileType = this.selectedFile.fileType
      cloneData.tax = this.selectedFile.tax
      cloneData.tenDigitCode = this.selectedFile.tenDigitCode
      cloneData.companyCname = this.selectedFile.companyCname
      cloneData.customsBroker = this.selectedFile.customsBroker
      cloneData.remark = this.selectedFile.remark
      cloneData.receiveCompany = this.selectedFile.receiveCompany
      cloneData.receivePerson = this.selectedFile.receivePerson
      cloneData.receiveTel = this.selectedFile.receiveTel
      cloneData.expressAddress = this.selectedFile.expressAddress
      this.oneFormData = cloneData
    },
    setFileTypeSelectValue(obj) {
      this.oneFormData[obj.key] = obj.code
      const typeValue = obj.interchangeCode
      // 选择文件类型  如果是报关单,提单，主单号自动带出
      this.bgdHp = TransmitFileTypeConstants.BGD_TYPE === typeValue
      if (!this.isGetMbl) return
      if (this.job === null) return
      if (this.job.lob === 'SE') {
        if (TransmitFileTypeConstants.TD_TYPE === typeValue) {
          this.oneFormData.fileNo = this.job.mbl
        } else if (TransmitFileTypeConstants.BGD_TYPE === typeValue || TransmitFileTypeConstants.HXD_TYPE === typeValue) {
          if (this.oneFormData.fileNo === '') {
            const fileNoArray = this.getFileNoDataProvider()
            if (fileNoArray != null && fileNoArray.length > 0) {
              this.oneFormData.fileNo = fileNoArray[0]
            }
          }
        } else if (TransmitFileTypeConstants.HBL_TYPE === typeValue) {
          // todo loadCargoDoc2 后端api 暂未开发
          this.loadCargoDoc2Handler()
        }
      } else {
        if (TransmitFileTypeConstants.BGD_TYPE === typeValue) {
          this.oneFormData.fileNo = this.job.mbl
        }
      }
      this.oneFormData.customsBroker = this.job.customsBroker
    },
    loadCargoDoc2Handler() {
      // todo 获取cargoDoc
      /* var cargoDocs:ArrayCollection = job.cargoDoc;
            if(cargoDocs != null && cargoDocs.length > 0)
            {
              for each(var hCargoDoc:SeaCargoDoc in cargoDocs)
              {
                if(hCargoDoc.docType == TransmitFileType.HBL_TYPE)
                {
                  txtFileNo.text = hCargoDoc.hblNbr2;
                  break;
                }
              }
            }*/
    },
    // 报关单号
    getFileNoDataProvider() {
      const soNo = this.job.soNo
      let source = []
      if (soNo !== '') {
        source = soNo.split('\n')
      }
      if (this.job.mbl !== '') {
        source.push(this.job.mbl)
      }
      if (!this.oneFormData.fileNo && !this.fileExits(source)) {
        source.push(this.oneFormData.fileNo)
      }
      return source
    },
    fileExits(source) {
      for (const str in source) {
        if (str === this.oneFormData.fileNo) {
          return true
        }
      }
      return false
    },
    tenDigitCodeChangeHandler() {
      if (this.oneFormData.tenDigitCode.length === 10) {
        this.isQuerying = true
        getBusinessByTenDigitCode(this.oneFormData.tenDigitCode).then(res => this.resultHandler(res.data))
      }
    },
    // file 保存后 保存或者更新 海关十字码
    businessSaveOrUpdate() {
      if (this.oneFormData.tenDigitCode.length !== 10) { return }

      if (!this.business || this.business.tenDigitCode !== this.oneFormData.tenDigitCode || this.business.companyCName !== this.oneFormData.companyCname) {
        // 公司名字被更新过
        const params = {
          tenDigitCode: this.oneFormData.tenDigitCode,
          companyCName: this.oneFormData.companyCname
        }
        businessCheckSaveUpdate(params)
      }
    },
    queryBusinessHandler() {
      if (this.oneFormData.companyCname !== '' && this.oneFormData.tenDigitCode.length !== 10) {
        console.log('11111111111111111111111111')
        this.isQuerying = true
        getBusinessByCompany(this.oneFormData.companyCname, false).then(res => this.resultHandler(res.data))
      }

      this.isQuerying = true
    },
    resultHandler(data) {
      this.isQuerying = false
      if (data && data.length > 0) {
        this.business = data[0]
        this.oneFormData.tenDigitCode = this.business.tenDigitCode
        this.oneFormData.companyCname = this.business.companyCname
      } else {
        this.business = null
      }
    },
    // 报关预录查询
    ylQueryClick() {
      ylQueryClickHandler(parseInt(cache.config.get('CustomerStatusQueryModel')), this.oneFormData, this.job)
    },
    // 报关状态查询
    async stateQueryClickHandler() {
      const queryModel = parseInt(cache.config.get('CustomerStatusQueryModel'))
      const bExcute = await stateQueryClickHandler(queryModel, this.oneFormData, this.job)
      if (!bExcute) return
      await getGetCustomsStatusResult(this.oneFormData).then(res => {
        this.getGetCustomsStatusResultHander(res.data)
      }
      )
    },
    getGetCustomsStatusResultHander(data) {
      this.isCustomsStatusTitle = true
      this.rowDataCustomsStatus = sortByMultiField(data, ['RECEIPT_DATE'], true)
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    // 联系人修改事件
    contactChange(item) {
      this.oneFormData.receivePerson = item.contactPerson
      if (item.hasOwnProperty('telephone')) {
        this.oneFormData.receiveTel = item.telephone
      } else {
        this.oneFormData.receiveTel = ''
      }
      if (item.hasOwnProperty('address')) {
        this.oneFormData.receiveAddress = item.address
      } else {
        this.oneFormData.receiveAddress = ''
      }
    }
  }
}
</script>

<style>
</style>
